var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainTopNavBar'),_c('section',{staticClass:"pad-lg light-gray-bg",attrs:{"id":"invite"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-sm-offset-2 text-center"},[_vm._t("content",function(){return [_vm._v("\n            default header\n          ")]}),_c('br')],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }